module.exports = __webpack_public_path__ + "static/media/exclamation.ca98eae4.png";